import { createSystemLogsRoutes } from "@template/modules/systemLogsRoutes";

export const protectedRoutes = createSystemLogsRoutes({
  meta: {
    requiresAdmin: true,
    title: "logs.title",
    breadcrumb: ["settings.system", "logs.title"],
    requiresAuth: true,
  },
});
